// TODO: Refactor - should use explicit enum values
export enum CampaignStatus {
  error,
  sent,
  scheduled,
  unscheduled,
  processing,
}
